/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProgressBarIndicator/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Complete from './Complete/index'
import ProgressBar from './ProgressBar/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ProgressBarIndicator({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/Progress/ProgressBarIndicator"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'ProgressBar'
let selectedIsCompleteValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'isComplete',
format: fromHelpers.view,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedIsCompleteValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'ProgressBar'}>
<ProgressBar
  viewPath={`${viewPath}/ProgressBar`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Complete'}>
<Complete
  viewPath={`${viewPath}/Complete`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}